import { generateTestId } from "@client-shared";

export const setTaxReportPanelTestId = (suffix: string) => generateTestId("TaxReportPanel", suffix);
